import React, { useMemo } from 'react';
import './Components/StudentProfile.css';
import { FaEye, FaDownload } from 'react-icons/fa';

const StudentProfile = () => {
  const studentId = useMemo(() => `STU${Date.now()}`, []);

  const handleViewClick = (subject) => {
    alert(`Viewing result for: ${subject}`);
  };

  const handleDownloadClick = (subject) => {
    alert(`Downloading result for: ${subject}`);
  };

  const examData = useMemo(() => {
    const baseTimestamp = Date.now();
    const data = [
      { type: 'Unit Test', date: '01/04/2025', subject: 'English', questions: 20, marks: 20, status: 'Pass' },
      { type: 'Unit Test', date: '18/04/2025', subject: 'Maths', questions: 20, marks: 19, status: 'Fail' },
      { type: 'Unit Test', date: '20/04/2025', subject: 'Marathi', questions: 20, marks: 20, status: 'Pass' },
      { type: 'Unit Test', date: '25/04/2025', subject: 'Maths', questions: 20, marks: 20, status: 'Pass' },
    ];

    return data.map((exam, index) => ({
      id: `EXAM${baseTimestamp + index}`,
      ...exam,
      Action: (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1vw' }}>
          
          <svg  className='eye-buttons' onClick={() => handleViewClick(exam.subject)}xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 25" fill="none"  style={{ cursor: 'pointer' }}>
  <path d="M12 16.5C13.25 16.5 14.3125 16.0625 15.1875 15.1875C16.0625 14.3125 16.5 13.25 16.5 12C16.5 10.75 16.0625 9.6875 15.1875 8.8125C14.3125 7.9375 13.25 7.5 12 7.5C10.75 7.5 9.6875 7.9375 8.8125 8.8125C7.9375 9.6875 7.5 10.75 7.5 12C7.5 13.25 7.9375 14.3125 8.8125 15.1875C9.6875 16.0625 10.75 16.5 12 16.5ZM12 14.7C11.25 14.7 10.6125 14.4375 10.0875 13.9125C9.5625 13.3875 9.3 12.75 9.3 12C9.3 11.25 9.5625 10.6125 10.0875 10.0875C10.6125 9.5625 11.25 9.3 12 9.3C12.75 9.3 13.3875 9.5625 13.9125 10.0875C14.4375 10.6125 14.7 11.25 14.7 12C14.7 12.75 14.4375 13.3875 13.9125 13.9125C13.3875 14.4375 12.75 14.7 12 14.7ZM12 19.5C9.56667 19.5 7.35 18.8208 5.35 17.4625C3.35 16.1042 1.9 14.2833 1 12C1.9 9.71667 3.35 7.89583 5.35 6.5375C7.35 5.17917 9.56667 4.5 12 4.5C14.4333 4.5 16.65 5.17917 18.65 6.5375C20.65 7.89583 22.1 9.71667 23 12C22.1 14.2833 20.65 16.1042 18.65 17.4625C16.65 18.8208 14.4333 19.5 12 19.5ZM12 17.5C13.8833 17.5 15.6125 17.0042 17.1875 16.0125C18.7625 15.0208 19.9667 13.6833 20.8
   12C19.9667 10.3167 18.7625 8.97917 17.1875 7.9875C15.6125 6.99583 13.8833 6.5 12 6.5C10.1167 6.5 8.3875 6.99583 6.8125 7.9875C5.2375 8.97917 4.03333 10.3167 3.2 12C4.03333 13.6833 5.2375 15.0208 6.8125 16.0125C8.3875 17.0042 10.1167 17.5 12 17.5Z" fill="black"
    />
</svg>
          
          <svg className='download-buttons' onClick={() => handleDownloadClick(exam.subject)}xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 25" fill="none" style={{ cursor: 'pointer' }}>
  <path d="M12 16.075C11.8667 16.075 11.7417 16.0542 11.625 16.0125C11.5083 15.9708 11.4 15.9 11.3 15.8L7.7 12.2C7.5 12 7.40417 11.7667 7.4125 11.5C7.42083 11.2333 7.51667 11 7.7 10.8C7.9 10.6 8.1375 
  10.4958 8.4125 10.4875C8.6875 10.4792 8.925 10.575 9.125 10.775L11 12.65V5.5C11 5.21667 11.0958 4.97917 11.2875 4.7875C11.4792 4.59583 11.7167 4.5 12 4.5C12.2833 4.5 12.5208 4.59583 12.7125 4.7875C12.9042 4.97917 
  13 5.21667 13 5.5V12.65L14.875 10.775C15.075 10.575 15.3125 10.4792 15.5875 10.4875C15.8625 10.4958 16.1 10.6 16.3 10.8C16.4833 11 16.5792 11.2333 16.5875 11.5C16.5958 11.7667 16.5 12 16.3 12.2L12.7 15.8C12.6 15.9 12.4917 15.9708 12.375 16.0125C12.2583 16.0542 12.1333 16.075 12
   16.075ZM6 20.5C5.45 20.5 4.97917 20.3042 4.5875 19.9125C4.19583 19.5208 4 19.05 4 18.5V16.5C4 16.2167 4.09583 15.9792 4.2875 15.7875C4.47917 15.5958 4.71667 15.5 5 15.5C5.28333 15.5 5.52083 15.5958 5.7125 15.7875C5.90417 15.9792 6 16.2167 6 16.5V18.5H18V16.5C18 16.2167 18.0958 15.9792 18.2875 15.7875C18.4792 15.5958 18.7167 15.5 19 15.5C19.2833 15.5 19.5208 15.5958 19.7125 15.7875C19.9042 15.9792 20 16.2167 20 16.5V18.5C20
    19.05 19.8042 19.5208 19.4125 19.9125C19.0208 20.3042 18.55 20.5 18 20.5H6Z" fill="#1F1F1F" />
</svg>
        </div>
      ),
    }));
  }, []);

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <h3>Personal Details</h3>
          <button className="-btn" onClick={handleBack}>Back</button>
          </div>
       

        <div className="profile-body">
          <div className="left-section"></div>

          <div className="info-section">
            <div className="info-grid">
              <div>
                <p>Rakesh Nikam</p>
                <p>Student ID: {studentId}</p>
                <p>Full Name : Rakesh Chandrakant Nikam</p>
                <p>Standard: 5th</p>
                <p>Email : rakeshnikam@gmail.com</p>
                <p>Gender : Male</p>
              </div>

              <div className='info-gridTwo'>
                <p>School Name : Vikas High-School, Vikhroli</p>
                <p>Division : A</p>
                <p>Contact : 1234567891</p>
                <p>Village : Vikhroli</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Exam Info Card */}
      <div className="card">
        <h3>Exam Details</h3>
        <table className="exam-table">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Exam Type</th>
              <th>Date</th>
              <th>Subject</th>
              <th>Questions</th>
              <th>Marks</th>
              <th>Action</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {examData.map((exam, index) => (
              <tr key={exam.id}>
                <td>{index + 1}</td>
                <td>{exam.type}</td>
                <td>{exam.date}</td>
                <td>{exam.subject}</td>
                <td>{exam.questions}</td>
                <td>{exam.marks}</td>
                <td style={{ textAlign: 'center' }}>{exam.Action}</td>
                <td>
                  <span className={`status ${exam.status === 'Pass' ? 'pass' : 'fail'}`}>
                    {exam.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentProfile;
